import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/gcstaff/staffloginpage/TeacherLoginPage.css";

const BookIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
    <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const TeacherForgotPasswordPage = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [cardIn,   setCardIn]   = useState(false);
  const [email,    setEmail]    = useState("");
  const [sent,     setSent]     = useState(false);
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);

  useEffect(() => { setTimeout(() => setCardIn(true), 60); }, []);

  const handleSubmit = (e) => {
  e.preventDefault();
  setError("");

  if (!email) {
    setError("Please enter your email address.");
    return;
  }

  setLoading(true);

  axios.post(`${baseUrl}/teacher/auth/forgotPassword`, {
    email: email
  })
  .then((res) => {
    if (res.data.success) {
      setSent(true);
    } else {
      setError(
        res.data.message ||
        res.data.error ||
        "Something went wrong. Please try again."
      );
    }
  })
  .catch((err) => {
    setError(
      err.response?.data?.message ||
      err.response?.data?.error ||
      "Something went wrong. Please try again."
    );
  })
  .finally(() => {
    setLoading(false);
  });
  };

  return (
    <div className="gcStaff-auth-bg">
      <div className={`gcStaff-auth-card ${cardIn ? "gcStaff-auth-card--in" : ""}`}>

        <div className="gcStaff-auth-logo">
          <BookIcon />
        </div>

        {!sent ? (
          <>
            <h2 className="gcStaff-auth-title">Forgot Password?</h2>
            <p className="gcStaff-auth-sub">Enter your email to receive a reset link</p>

            {error && <div className="gcStaff-auth-error">{error}</div>}

            <form className="gcStaff-auth-form" onSubmit={handleSubmit} noValidate>
              <input
                className="gcStaff-auth-input"
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
              />
              <button
                type="submit"
                className={`gcStaff-auth-btn ${loading ? "gcStaff-auth-btn--loading" : ""}`}
                disabled={loading}
              >
                {loading ? <span className="gcStaff-auth-spinner" /> : "Send Reset Link"}
              </button>
            </form>
          </>
        ) : (
          <div className="gcStaff-auth-success">
            <div className="gcStaff-auth-success-icon">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#0f8a65" strokeWidth="1.8"/>
                <path d="M8 12l3 3 5-5" stroke="#0f8a65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="gcStaff-auth-success-title">Email Sent!</h3>
            <p className="gcStaff-auth-success-msg">
              We've sent a password reset link to <strong>{email}</strong>. Please check your inbox.
            </p>
            <button
              className="gcStaff-auth-btn"
              onClick={() => navigate("/teacher/login")}
            >
              Back to Login
            </button>
          </div>
        )}

        <button className="gcStaff-auth-back" onClick={() => navigate("/")}>
          ← Back to Home
        </button>

      </div>
    </div>
  );
};

export default TeacherForgotPasswordPage;